const HUB_QR_HOSTS = new Set([
	"qr.bacehub.de",
	"qr.staging.bacehub.de",
	// Staging QR redirect on the Tailscale network
	"qr-staging.badger-parrotfish.ts.net",
]);

/** Whether a scanned URL comes from a printed bacehub hub QR code (e.g. https://qr.bacehub.de/buexe-a). */
export const isHubQrUrl = (url: URL): boolean => HUB_QR_HOSTS.has(url.hostname);
